import React, { Component } from 'react';
import Abogado from '../components/Abogado';
import '../css/MainContent.css';
import abogadoHero from '../assets/Abogados logo.png'

const Abogados = props => {

        return (
            <div className="mainContentAll">
                <div className="abogadoHero">
                    <img src={abogadoHero} alt="Imagen Abogados"/>
                </div>
                <div className="lawyer-title">
                    <h2 className="font" style={{fontSize:22, fontWeight: "bold"}}>{props.data.contenido.councels.title} </h2>
                    <p style={{fontSize:13}}>{props.data.contenido.subtitle} </p>
                </div>
                <div className="lawyer-component">
                    <Abogado
                        data={props.data}
                        abogadoPage="/guillermo"
                        Nombre="Guillermo García"
                        Rol={props.data.contenido.councels.rol}
                    />
                     <Abogado
                        data={props.data}
                        abogadoPage="/daniel"
                        Nombre="Ing. Daniel Ríos Zertuche"
                        Rol={props.data.contenido.councels.rol}
                    />
                   
                   
                   
                </div>
            </div>
        );
}

export default Abogados;